<template>
  <h1 class="text-left">Alle statistieken</h1>
  <div class="row">
    <div class="col-6">
      <PieChart class="pie-chart" />
    </div>
    <div class="col-6">
      <HorizontalBarChart class="horizontal-bar-chart" />
    </div>
  </div>
  <hr />
  <h1 class="text-left">Geselecteerde ontvangers</h1>
  <div class="row">
    <div class="col-5 q-pa-sm">
      <BarChart class="bar-chart" />
    </div>
    <div class="col-7 q-pa-sm table-container">
      <q-table
        v-if="barClicked"
        class="statistics-table"
        dense
        :title="tableName"
        :columns="columns"
        :rows="tableRows"
        :pagination="pagination"
        :wrap-cells="true"
        :square="true"
        :flat="true"
        :bordered="true"
        row-key="name"
        @row-click="rowClickHandler"
      />
    </div>
    <q-dialog v-model="showDetails">
      <q-card class="details-card">
        <q-card-section class="row items-center q-pb-none details-card-header">
          <div class="text-h6">Samenvatting</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-card-section >
          {{ rowDetails }}
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { ref, computed } from 'vue';
import PieChart from '../../components/chart-components/PieChart.vue';
import BarChart from '../../components/chart-components/BarChart.vue';
import HorizontalBarChart from '../../components/chart-components/HorizontalBarChart.vue';
import store from '../../store/index.js';

export default {
  name: 'StatisticsChartTab',
  components: {
    PieChart,
    BarChart,
    HorizontalBarChart,
  },

  setup() {
    const columns = [
      {
        name: 'schemeName',
        label: 'Regeling',
        field: 'schemeName',
        sortable: true,
        style: 'width: 30%',
        align: 'left',
      },
      {
        name: 'subject',
        label: 'Aanvraagtitel',
        field: 'subject',
        sortable: true,
        style: 'width: 30%',
        align: 'left',
      },
      {
        name: 'amount',
        label: 'Bedrag',
        field: 'amount',
        sortable: true,
        style: 'width: 15%',
        align: 'left',
      },
    ];

    const showDetails = ref(false);

    const rowDetails = ref('');

    const pagination = ref({
      rowsPerPage: 10,
    });

    const tableRows = computed({
      get: () => store.state.statistics.tableRows,
    });

    const tableName = computed({
      get: () => store.state.statistics.tableName,
    });

    const barClicked = computed({
      get: () => store.state.statistics.barChartClicked,
    });
    return {
      columns,
      pagination,
      tableRows,
      tableName,
      showDetails,
      rowDetails,
      barClicked,
      rowClickHandler(evt, row) {
        console.log(evt);
        showDetails.value = true;
        rowDetails.value = row.summary;
        if(row.summary == ''){
          rowDetails.value = 'Samenvatting niet beschikbaar';
        }
      },
    };
  },
};
</script>
